import React, { forwardRef } from 'react';
import Section, { size } from '../generic/Section';

import ProductListContent from './ProductListContent';

const ProductList = forwardRef(ProductListImpl);
export default ProductList;

function ProductListImpl({ products }, ref) {
  if (!products) {
    return null;
  }

  return (
    <Section size={size.max} ref={ref}>
      {products.map(product => {
        return <ProductListContent key={product.id} item={product} />;
      })}
    </Section>
  );
}
